import { Table } from '@material-ui/core';
import { Form } from '@unform/web';
import { darken } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-height: 100%;

  .header {
    h2 {
      font-family: Sora, sans-serif;
      font-size: 24px;
      font-weight: 600;
      color: #101d40;
    }

    & > p {
      font-family: Sora, sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #101d40;
    }
  }

  .create_user {
    display: flex;
    justify-content: flex-end;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 13px 18px;
      border-radius: 5px;
      font-family: Sora, sans-serif;
      font-weight: 600;
      font-size: 15px;
      border: none;
      cursor: pointer;
      background-color: #329bfc;
      color: #ffffff;
      width: 100%;
      max-width: 300px;
      text-decoration: none;

      &:hover:not(:disabled) {
        background-color: ${darken(0.1, '#329bfc')};
      }
    }
  }

  header {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .previous_page {
      border: none;
      background: transparent;
      display: flex;
      align-items: center;
      color: #9e9e9e;
      gap: 4px;
      font-size: 16px;
      font-weight: 600;
    }

    .previous_page:hover {
      color: #329bfc;
    }

    h1 {
      font-size: 24px;
      font-weight: 600;
      color: #263238;
    }

    p {
      color: #757575;
      font-size: 16px;
      font-weight: 300;
    }
  }
`;

export const CustomForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 16px;

  label {
    display: block;
    margin-bottom: 6px;
    font-weight: 500;
    font-size: 14px;
    font-family: 'Sora', sans-serif;
    color: #101d40;
  }

  .multi {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;

    & > div {
      min-width: 200px;
      flex: 1;
    }
  }

  .field {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 200px;
  }

  .field-note {
    font-size: 12px;
    color: #757575;
    margin-top: 4px;
  }

  .field-error {
    font-size: 12px;
    color: #f64444;
    margin-top: 4px;
  }

  .buttons {
    display: flex;
    justify-content: center;
    gap: 16px;
    width: 100%;

    & > button {
      max-width: 250px;
      min-width: 200px;
    }
  }
`;

export const CustomTable = styled(Table)`
  border-collapse: initial;
  font-family: Sora, sans-serif;
`;

export const TableHeader = styled.thead`
  display: grid;
  column-gap: 20px;
  grid-template-rows: 1fr;
  grid-template-columns: minmax(180px, 1fr) 90px 80px minmax(140px, 1fr) 50px 50px 120px;
  padding: 16px;
  font-family: 'Sora', sans-serif;
  font-size: 12px;
  color: #acb3be;
  font-weight: 600;
  align-items: center;
`;

export const TableBody = styled.tbody`
  font-family: 'Sora', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #101d40;
`;

export const ContainerList = styled.div`
  border: 2px solid rgb(230, 239, 251);
  border-radius: 5px;
  overflow-x: auto;
`;

export const TableRow = styled.div`
  display: grid;
  column-gap: 20px;
  grid-template-rows: 1fr;
  grid-template-columns: minmax(180px, 1fr) 90px 80px minmax(140px, 1fr) 50px 50px 120px;
  border-top: 1px solid #e6effb;
  padding: 16px;
  align-items: center;
  background-color: #ffffff;
`;

export const TableCellRow = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-family: Sora, sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #101d40;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  a {
    display: flex;
  }

  svg:hover {
    color: #329bfc;
    cursor: pointer;
  }

  button {
    background: transparent;
    border: none;
    cursor: pointer;
    color: #f64444;
  }
`;

export const ModalContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 8px;
  padding: 32px;
  width: 90%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  outline: none;

  h1 {
    font-family: 'Sora', sans-serif;
    font-size: 20px;
    color: #101d40;
    text-align: center;
  }

  p {
    text-align: center;
    color: #757575;
    font-size: 14px;
  }

  .modal-actions {
    display: flex;
    gap: 16px;
    width: 100%;
  }
`;
